import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'
import toNumber from 'lodash/toNumber'
import type { ModelFamilyEnum } from '@ztechapps/common.contract'

export type ModelRateFormValues = {
  model?: string
  family?: ModelFamilyEnum
  inputUsdPerMillion?: number | string
  outputUsdPerMillion?: number | string
  markupPct?: number | string
  active?: boolean
  notes?: string
}

/**
 * Client-side mirror of the field rules a `ModelRate` row must satisfy — `model` and `family`
 * present, `inputUsdPerMillion`/`outputUsdPerMillion` present and non-negative, `markupPct`
 * non-negative when supplied. No server-side numeric field rule guards this already-seeded
 * collection — adding one could make legacy rows permanently uneditable — so this check is display
 * feedback only. Returns an error message per failing field, keyed by field name.
 */
export const validateModelRateForm = (values: ModelRateFormValues): Record<string, string> => {
  const errors: Record<string, string> = {}

  if (isEmpty(values.model)) errors.model = 'Model is required.'
  if (isEmpty(values.family)) errors.family = 'Family is required.'

  if (isNil(values.inputUsdPerMillion) || values.inputUsdPerMillion === '' || toNumber(values.inputUsdPerMillion) < 0) {
    errors.inputUsdPerMillion = 'Input USD per million must be a non-negative number.'
  }
  if (
    isNil(values.outputUsdPerMillion) ||
    values.outputUsdPerMillion === '' ||
    toNumber(values.outputUsdPerMillion) < 0
  ) {
    errors.outputUsdPerMillion = 'Output USD per million must be a non-negative number.'
  }
  if (!isNil(values.markupPct) && values.markupPct !== '' && toNumber(values.markupPct) < 0) {
    errors.markupPct = 'Markup percent must not be negative.'
  }

  return errors
}
